<template>
    <div>
        <b-modal
            id="onlineModal"
            ref="onlineModal"
            @shown="shown"
            :lazy="true"
            @hidden="close"
            :scrollable="true"
            title-tag="h2"
            title="Reschedule Appointment"
        >
            <form class="form-horizontal pl-2">
                <div class="form-group row">
                    <label for="type" class="col-sm-3 col-form-label"
                        >Type:</label
                    >
                    <div class="col-sm-9">
                        <b-form-select
                            id="appointment_type"
                            v-model="data.appointment_type"
                            v-validate="'required'"
                            @change="typeChange"
                            :disabled="!appointmentTypes.length"
                            class="form-control"
                            name="appointment_type"
                            :options="appointmentTypes"
                        >
                        </b-form-select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="reason" class="col-sm-3 col-form-label"
                        >Complaint:</label
                    >
                    <div class="col-sm-9">
                        <input
                            id="reason"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('reason') }"
                            v-model="data.reason"
                            type="text"
                            class="form-control"
                            name="reason"
                            placeholder="Complaint (required)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="staff_id" class="col-sm-3 col-form-label"
                        >Assign To:</label
                    >
                    <div class="col-sm-9">
                        <b-form-select
                            id="staff_id"
                            v-model="data.staff_id"
                            :disabled="!providers.length"
                            class="form-control"
                        >
                            <option disabled value="0"
                                >Provider (Required)</option
                            >
                            <option
                                v-for="provider in providers"
                                :key="provider.id"
                                :value="provider.id"
                                >{{ provider.providerName }}</option
                            >
                        </b-form-select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="client_id" class="col-sm-3 col-form-label"
                        >Client:</label
                    >
                    <div class="col-sm-9">
                        <vet-select
                            id="client_id"
                            v-model="data.client"
                            @input="onClientChange"
                            v-validate="''"
                            module="client"
                            placeholder="Client name (optional)"
                            name="client_id"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Patient:</label
                    >
                    <div class="col-sm-9">
                        <vet-select
                            id="patient_id"
                            v-model="data.patient"
                            :disabled="!(data.client && data.client.id)"
                            v-validate
                            :client-id="data.client_id"
                            @input="patientChange"
                            :options="poptions"
                            module="client-patient"
                            placeholder="Patient name (optional)"
                            label="name"
                            name="patient_id"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="start" class="col-sm-3 col-form-label"
                        >From:</label
                    >
                    <div class="col">
                        <vet-datetime
                            v-model="data.start"
                            v-validate="'required'"
                            :placeholder="{
                                date: 'Appointment Date (required)',
                                time: 'Start Time (required)'
                            }"
                            rules="required"
                            name="start"
                            container="#onlineModal"
                            format="moment"
                        ></vet-datetime>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="end" class="col-sm-3 col-form-label">To:</label>
                    <div class="col">
                        <vet-datetime
                            v-model="data.end"
                            :min-time="data.start"
                            v-validate="'required'"
                            :placeholder="{
                                date: 'Appointment Date (required)',
                                time: 'End Time (required)'
                            }"
                            rules="required"
                            name="end"
                            format="moment"
                            container="#onlineModal"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Email Message:</label
                    >
                    <div class="col-sm-9">
                        <ContentEditable
                            id="confirmation_message"
                            v-model="confirmation_message"
                            :template="template_object"
                            :noHTML="false"
                            tag="div"
                            class="form-control"
                        >
                        </ContentEditable>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="reminder_option" class="col-sm-3 col-form-label"
                        >Remind by:</label
                    >
                    <div class="col-sm-9">
                        <select
                            id="reminder_option"
                            v-model="data.reminder_option"
                            class="form-control"
                        >
                            <option value="4">No reminder</option>
                            <option
                                :value="opt.id"
                                v-for="opt in reminder_options_filter"
                                :key="opt.id"
                                >{{ opt.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <div
                    v-if="
                        data.reminder_option == 1 || data.reminder_option == 5
                    "
                    class="form-group row"
                >
                    <label
                        for="reminder_time_period"
                        class="col-sm-3 col-form-label"
                        >Send:</label
                    >
                    <div class="col-sm-9 pr-0">
                        <div class="row container-fluid pr-0">
                            <input
                                v-model="reminderSetting.reminder_send"
                                v-validate="'required|numeric'"
                                type="text"
                                :placeholder="
                                    _periodText(
                                        reminderSetting.time_period_id
                                    ) + ' (required)'
                                "
                                class="form-control col mr-2"
                            />
                            <select
                                v-model="reminderSetting.time_period_id"
                                name="reminder_time_period"
                                class="form-control col mr-2"
                                aria-invalid="false"
                            >
                                <option value="4" selected="selected"
                                    >Day(s)</option
                                >
                                <option value="5">Week(s)</option>
                                <option value="6">Month(s)</option>
                                <option value="7">Year(s)</option>
                            </select>
                            <select
                                v-model="
                                    reminderSetting.reminder_send_option_id
                                "
                                class="form-control col"
                                aria-invalid="false"
                            >
                                <option value="1">Before Due</option>
                                <option value="2">After Due</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-if="
                        data.reminder_option == 1 || data.reminder_option == 5
                    "
                    class="form-group row"
                >
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Reminder:</label
                    >
                    <div class="col-sm-9">
                        <ContentEditable
                            id="reminder_message"
                            key="1"
                            v-if="
                                data.reminder_option ==
                                APPOINTMENTS.REMINDER_OPTIONS.EMAIL
                            "
                            v-model="reminder_message"
                            :template="template_object"
                            :noHTML="false"
                            tag="div"
                            class="form-control"
                        ></ContentEditable>
                        <textarea
                            id="sms_reminder_message"
                            v-else-if="
                                data.reminder_option ==
                                APPOINTMENTS.REMINDER_OPTIONS.SMS
                            "
                            v-model="sms_reminder_message"
                            :maxlength="maxCharacters"
                            class="form-control h-auto"
                            rows="3"
                        ></textarea>
                        <TextLimitIndicator
                            v-if="
                                data.reminder_option ==
                                APPOINTMENTS.REMINDER_OPTIONS.SMS
                            "
                            class="mb-0"
                            :max-length="maxCharacters"
                            :text="sms_reminder_message"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Notes:</label
                    >
                    <div class="col-sm-9">
                        <textarea
                            id="notes"
                            v-model="data.note"
                            class="form-control"
                            placeholder="Notes (optional)"
                            rows="5"
                            style="height: 80px;"
                        ></textarea>
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.onlineModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="save" v-else variant="primary"
                        >Reschedule</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import vetSelect from "@/module/commons/vet-select.vue";
import vetDatetime from "@/module/commons/date-time-picker.vue";
import ContentEditable from "@/module/commons/content-editable-template";
import TextLimitIndicator from "@/components/commons/text-limit-indicator";
import ScheduleHelper from "@/module/schedule/helper";
import APPOINTMENTS from "@/constants/appointments";
import { get, sortBy, cloneDeep, map, find } from "lodash";

export default {
    components: {
        vetSelect,
        vetDatetime,
        ContentEditable,
        TextLimitIndicator
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            resources: {},
            data: {
                client: {},
                patient: {},
                reminder_option: 4,
                client_id: null,
                patient_id: null,
                appointment_type: null,
                staff_id: null,
                is_staff: 0,
                start: null,
                oldDataStart: null,
                end: null
            },
            start: null,
            end: null,
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            timePickerOptions: {
                format: "hh:mm A"
            },
            providers: [],
            poptions: [],
            confirmation_message: null,
            reminder_message: null,
            sms_reminder_message: null,
            rawReminderMessage: null,
            appointmentTypes: [],
            reminder_options: [
                { id: 1, label: "Email" },
                { id: 3, label: "Mail" },
                { id: 2, label: "Phone" },
                { id: 5, label: "SMS (Text)" }
            ],
            reminderSetting: {},
            client_reminder_options: [],
            loading: false,
            original_appointment_date: null,
            original_appointment_time: null,
            maxCharacters: 1500,
            APPOINTMENTS
        };
    },
    computed: {
        reminder_options_filter() {
            let self = this;
            return map(self.client_reminder_options, n => {
                return find(self.reminder_options, { id: parseInt(n) });
            });
        },
        period_txt() {
            switch (parseInt(this.reminderSetting.time_period_id)) {
                case 4:
                    return "Days";
                case 5:
                    return "Weeks";
                case 6:
                    return "Months";
                case 7:
                    return "Years";
                default:
                    return "Days";
            }
        },
        template_object() {
            let appointment_type_text = $(
                "#appointment_type option:selected"
            ).text();
            return {
                APPOINTMENT_DATE: this.data.start
                    ? this.data.start.format(this.datePickerOptions.format)
                    : "",
                APPOINTMENT_TIME: this.data.start
                    ? this.data.start.format(this.timePickerOptions.format)
                    : "",
                APPOINTMENT_OLDDATE: this.data.oldDataStart
                    ? this.data.oldDataStart.format(
                          this.datePickerOptions.format
                      )
                    : "",
                APPOINTMENT_OLDTIME: this.data.oldDataStart
                    ? this.data.oldDataStart.format(
                          this.timePickerOptions.format
                      )
                    : "",
                APPOINTMENT_COMPLAINT: this.data.reason ? this.data.reason : "",
                APPOINTMENT_PROVIDER: this.data.staff
                    ? this.data.staff.label
                    : "",
                APPOINTMENT_TYPE: appointment_type_text.substr(
                    0,
                    appointment_type_text.lastIndexOf("(")
                ),
                APPOINTMENT_NOTE: this.data.note ? this.data.note : "",
                PATIENT_NAME: this.data.patient ? this.data.patient.name : "",
                RECIPIENT_FIRST_NAME: this.data.client
                    ? this.data.client.firstname
                    : "",
                OWNER_FIRST_NAME: this.data.client
                    ? this.data.client.firstname
                    : "",
                CLINIC_PHONE: get(this, "$root.setting.business.phone"),
                CLINIC_EMAIL: get(this, "$root.setting.business.email"),
                CLINIC_NAME: get(this, "$root.setting.business.name")
            };
        }
    },
    watch: {
        "data.client_id": {
            handler(newData, oldData) {
                if (newData) {
                    if (newData && oldData && oldData != newData) {
                        this.data.patient = null;
                        this.data.location = null;
                    }
                } else {
                    this.data.patient_id = null;
                    this.data.patient = null;
                    this.poptions = [];
                }
            }
        },
        "data.staff_id": {
            handler(newData, oldData) {
                if (newData && oldData && oldData != newData) {
                    this.data.staff = find(this.providers, { id: newData });
                    this.data.is_staff = this.data.staff.type;
                }
            }
        },
        "data.start"() {
            this.typeChange();
        },
        "data.reminder_option"(value) {
            if (
                value === APPOINTMENTS.REMINDER_OPTIONS.SMS &&
                this.sms_reminder_message &&
                /(?=.*{)(?=.*})/gm.test(this.sms_reminder_message)
            ) {
                this.sms_reminder_message = this.populateReminderText(
                    this.sms_reminder_message,
                    this.template_object
                );
            }
        },
        template_object: {
            immediate: true,
            handler(value) {
                if (this.sms_reminder_message) {
                    this.sms_reminder_message = this.populateReminderText(
                        this.sms_reminder_message,
                        value
                    );
                }
            },
            deep: true
        }
    },
    mounted() {},
    methods: {
        open(id) {
            this.getProviders();
            this.getReasons();
            this._getDefaultReminderSetting().then(result => {
                this.reminderSetting = result;
                this.getAppointmentData(id);
            });
            this.datePickerOptions.format = this.getDateFormat();

            this.$refs.onlineModal.show();
        },
        shown() {
            // reset all data
            this.page = "appointment";
        },
        close() {
            this.$socket.client.emit("v-broadcast-all", { action: "cancel" });
        },
        getAppointmentData(id) {
            let self = this;
            return self.$http
                .get(process.env.SCHEDULE_SERVICE + "appointment/" + id)
                .then(function (response) {
                    self.data = response.data.response.resources;

                    self.original_appointment_date = moment(
                        self.data.start
                    ).format(self.datePickerOptions.format);
                    self.original_appointment_time = moment(
                        self.data.start
                    ).format(self.timePickerOptions.format);

                    self.data.oldDataStart = moment(self.data.start).tz(
                        self._timeZone
                    );

                    self.data.start = moment(self.data.start).tz(
                        self._timeZone
                    );
                    self.data.end = moment(self.data.end).tz(self._timeZone);

                    self.getClientReminderOptions();
                    self.getEmailMessages();

                    //check if reminder option is sms & client has mobile number
                    //check if reminder option is email & client has email address
                    if (
                        get(self, "reminderSetting.reminder_type_id") == 5 &&
                        self.data.client.mobile
                    ) {
                        self.data.reminder_option = get(
                            self,
                            "reminderSetting.reminder_type_id"
                        );
                    } else if (
                        get(self, "reminderSetting.reminder_type_id") == 1 &&
                        self.data.client.email
                    ) {
                        self.data.reminder_option = get(
                            self,
                            "reminderSetting.reminder_type_id"
                        );
                    } else {
                        self.data.reminder_option = 4;
                    }
                });
        },
        getReasons() {
            let self = this;

            return this.$http
                .get(process.env.BARRACUDA + "account/appointment-type")
                .then(function (response) {
                    self.appointmentTypes = sortBy(
                        response.data.response?.resource?.data?.map(type => ({
                            value: type.id,
                            text:
                                type.type + " (" + type.duration + " minutes)",
                            name: type.type,
                            duration: type.duration
                        })),
                        "index"
                    );
                    if (!self.data.appointment_type) {
                        self.data.appointment_type =
                            self.appointmentTypes[0].value;
                    }
                });
        },
        dateChange(event, element) {
            this.data[element] = event.date;
        },
        typeChange(event) {
            let appointmentType = find(this.appointmentTypes, {
                value: event ? event.target.value : this.data.appointment_type
            });
            if (appointmentType && this.data.start) {
                this.data.end = this.data.start
                    .clone()
                    .add(appointmentType.duration, "m");
            }
        },
        getProviders() {
            let self = this;
            this.$http
                .get(
                    process.env.BARRACUDA +
                        "account/schedule-columns?is_settings=0"
                )
                .then(function (response) {
                    self.providers = get(
                        response,
                        "data.response.resource.data",
                        []
                    );

                    self.providers = _.map(self.providers, element => ({
                        ...element,
                        id: element.type == 1 ? element.staff.id : element.id,
                        providerName:
                            element.display_name == "" ||
                            element.display_name == null
                                ? element.staff.firstname +
                                  " " +
                                  element.staff.lastname
                                : element.display_name
                    }));
                });
        },
        onClientChange(client) {
            let self = this;

            self.data.client_id = client ? client.id : null;
            self.data.type = client ? 0 : 1;
        },
        patientChange(patient) {
            this.data.patient_id = patient ? patient.id : null;
            // this.patientNotes().then(() => {
            //     this.popupNotification();
            // });
        },
        getEmailMessages() {
            let self = this;

            return self.$http
                .get(
                    process.env.SCHEDULE_SERVICE +
                        "online-booking/render-reschedule-message"
                )
                .then(function (response) {
                    if (response.data.response.message.code == 200) {
                        self.confirmation_message =
                            response.data.response.resources.confirmation_message;
                        self.reminder_message =
                            response.data.response.resources.reminder_message;
                        self.sms_reminder_message =
                            response.data.response.resources.sms_reminder_message;
                    }
                });
        },
        getClientReminderOptions() {
            let self = this;
            this.$http
                .get(
                    process.env.ACTOR_SERVICE +
                        "client/" +
                        self.data.client.id +
                        "/reminder-option-ids"
                )
                .then(function (response) {
                    // self.client_reminder_options =
                    //     response.data.response.resource.reminder_options;
                    if (response.data.response.message.code == 200) {
                        self.client_reminder_options = response.data.response.resources.map(
                            option => parseInt(option)
                        );
                        return self.client_reminder_options;
                    }
                });
        },
        save() {
            let self = this;

            self.loading = true;

            let promise = null;

            promise = Promise.resolve(true); // -- empty promise

            promise.then(result => {
                if (result) {
                    let post = cloneDeep(self.data);
                    post.end = moment(post.end).unix();
                    post.start = moment(post.start).unix();
                    post.module = "reschedule";

                    post.reminder = {
                        reminder_send: self.reminderSetting.reminder_send,
                        time_period_id: self.reminderSetting.time_period_id,
                        reminder_send_option_id:
                            self.reminderSetting.reminder_send_option_id,
                        reminder_type_id: self.data.reminder_option,
                        sms_message: self.sms_reminder_message,
                        message: self.reminder_message
                    };

                    post.confirmation = {
                        confirmation_method: "BY_EMAIL",
                        confirmation_subject: "",
                        confirmation_message: self.confirmation_message
                    };

                    return this.$http
                        .post(
                            process.env.SCHEDULE_SERVICE +
                                "accept-appointment/" +
                                self.data.id,
                            post
                        )
                        .then(function (response) {
                            if (response.data.response.message.code == 200) {
                                self._message(
                                    "Appointment successfully saved and confirmation emailed"
                                );
                                self.$refs.onlineModal.hide();
                                self.$parent.refetch();
                            } else {
                                self._message(
                                    "Error processing your request",
                                    "danger"
                                );
                            }
                        });
                }
            });
        },
        populateReminderText(string, template) {
            // this method is same as plainTranslate in commons/content-editable-template.vue component.

            if (!this.rawReminderMessage) {
                this.rawReminderMessage = string;
            }

            return this.rawReminderMessage.replace(/{(\w+)}/g, function (
                key,
                cleanKey
            ) {
                return template[cleanKey] &&
                    Object.prototype.hasOwnProperty.call(template, cleanKey)
                    ? template[cleanKey]
                    : "[ - ]";
            });
        }
    }
};
</script>
